module.exports = __webpack_public_path__ + "img/0006.36c734bf.png";